<div class="field row" *ngIf="value != null && saleType != saleTypes.cash">
    <label class="field-label" translate="payoffAmount"></label>
    <span class="field-data">
        <span class="qa-payoff-value">{{value | localeCurrency}}</span>
        <a class="edit-icon qa-payoff-edit-link" *ngIf="permissions.editPayoffAmount && paymentsRemaining > 0 && !paidOff" href="#" (click)="inputPayoffModal()" title="{{'adjustPayoff' | translate}}">
            <icon class="icon aa-icon-core-edit-icon-000000"></icon>
        </a>
    </span>
</div>
